import { render, staticRenderFns } from "./uploadParchment.vue?vue&type=template&id=4c2f6e3b"
import script from "./uploadParchment.vue?vue&type=script&lang=js"
export * from "./uploadParchment.vue?vue&type=script&lang=js"
import style0 from "./uploadParchment.vue?vue&type=style&index=0&id=4c2f6e3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports